export type InsightTodayPageViewName = 'insight_sample' | 'insight_today';

export type InsightTodayPageView =
  | { pageName: 'insight_sample' }
  | { pageName: 'insight_today'; insightId?: number };

export type InsightTodayPageViewInput = {
  hasLoaded: boolean;
  isInsightEnabled: boolean;
  hasProfile: boolean;
  isSampleEnabled: boolean;
  /** undefined は未取得、null は当日分が未生成 */
  insightId: number | null | undefined;
  isInsightShown: boolean;
  trackedPageNames: ReadonlySet<InsightTodayPageViewName>;
};

/**
 * 同じマウント中に同じ表示を二重に数えないよう、送信済みのページ名を見て送るかを決める。
 * サンプルから登録した直後は生成中の表示を挟むため、
 * 実際の発想のヒントが表示されてから insight_today を送る。
 */
export const resolveInsightTodayPageView = ({
  hasLoaded,
  isInsightEnabled,
  hasProfile,
  isSampleEnabled,
  insightId,
  isInsightShown,
  trackedPageNames,
}: InsightTodayPageViewInput): InsightTodayPageView | null => {
  if (!hasLoaded) return null;
  if (isSampleEnabled && !hasProfile) {
    return trackedPageNames.has('insight_sample')
      ? null
      : { pageName: 'insight_sample' };
  }
  if (trackedPageNames.has('insight_today')) return null;
  if (trackedPageNames.has('insight_sample')) {
    if (!isInsightShown || typeof insightId !== 'number') return null;
    return { pageName: 'insight_today', insightId };
  }
  // 業務情報が未登録のユーザーは取得しないので、読み込み完了の時点で送る。
  if (!isInsightEnabled) return { pageName: 'insight_today' };
  // 当日分が未生成だと最初の取得は id: null で返り、直後の生成開始で id が付くので、id が付くまで待つ。
  if (typeof insightId !== 'number') return null;
  return { pageName: 'insight_today', insightId };
};
